export default "__VITE_ASSET__DobEgiug__"